import { useState } from 'react';
import OnFarmSingleDeposit from './deposit-components/OnFarmSingleDeposit';
import OnFarmBulkDeposit from './deposit-components/OnFarmBulkDeposit';
import { LABEL_CONSTANTS, NAVIGATION_LINK_CONSTANTS } from '../../../constants/common';

type DepositMode = 'single' | 'bulk';

const depositModeOptions: { mode: DepositMode; label: string }[] = [
  { mode: 'single', label: LABEL_CONSTANTS.SINGLE_DEPOSIT },
  { mode: 'bulk', label: LABEL_CONSTANTS.BULK_DEPOSIT },
];

const OnFarmDeposit = (): JSX.Element => {
  const [depositMode, setDepositMode] = useState<DepositMode>('single');
  const isBulkDeposit = depositMode === 'bulk';

  return (
    <div className="on-farm on-farm-deposit">
      <div className="on-farm-action card">
        <div className="deposit-header">
          <h1>{NAVIGATION_LINK_CONSTANTS.DEPOSIT}</h1>
        </div>
        <div className="deposit-section-header">
          <h2>{isBulkDeposit ? LABEL_CONSTANTS.BULK_DEPOSIT : LABEL_CONSTANTS.ITEM_INFO}</h2>
          <div className="deposit-mode-toggle">
            {depositModeOptions.map(option => (
              <button
                key={option.mode}
                type="button"
                className={`deposit-mode-button ${depositMode === option.mode ? 'active' : ''}`}
                onClick={() => setDepositMode(option.mode)}>
                {option.label}
              </button>
            ))}
          </div>
        </div>
        {isBulkDeposit ? <OnFarmBulkDeposit /> : <OnFarmSingleDeposit />}
      </div>
    </div>
  );
};

export default OnFarmDeposit;
